/**
 * ContractTypeModern - MIGRATED to use CRUDPage template
 * 
 * Before: 257 lines
 * After: ~90 lines (65% reduction!)
 */

import React from 'react';
import { Box, Chip } from '@mui/material';
import { FileText } from 'lucide-react';

import CRUDPage from '../Components/UI/CRUDPage';

// Field definitions
const contractTypeFields = [
  {
    name: 'type_code',
    label: 'Agreement Type Code',
    type: 'text',
    disabled: true,
    helperText: 'Auto-generated'
  },
  {
    name: 'type_name',
    label: 'Agreement Type Name',
    type: 'text',
    required: true,
    validation: {
      required: 'Agreement type name is required',
      minLength: { value: 2, message: 'Name must be at least 2 characters' }
    }
  }
];

// Column definitions
const columns = [
  {
    field: 'type_code',
    headerName: 'Agreement Type Code',
    sortable: true,
    renderCell: ({ value }) => (
      <Chip
        label={value || 'N/A'}
        size="small"
        variant="outlined"
        sx={{ fontWeight: 500 }}
      />
    )
  },
  {
    field: 'type_name',
    headerName: 'Agreement Type Name',
    sortable: true,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FileText size={16} color="#6C8EBF" />
        <span style={{ fontWeight: 500 }}>{value}</span>
      </Box>
    )
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    align: 'right'
  }
];

function ContractTypeModern() {
  return (
    <CRUDPage
      title="Agreement Type Management"
      subtitle="Manage agreement type configurations"
      icon={FileText}
      columns={columns}
      fields={contractTypeFields}
      searchFields={['type_name', 'type_code']}
      permissions={{
        resource: 'Admin',
        module: 'contractType'
      }}
      crudConfig={{
        endpoint: '/api/contract-types',
        entityName: 'Agreement Type',
        entityNamePlural: 'Agreement Types',
        useOrgId: true,
        deleteWarning: 'Agreements using this type may be affected.'
      }}
    />
  );
}

export default ContractTypeModern;
